import axios from "axios";
import ENDPOINTS from "./end-points";
import Storage from "@/services/storage";
import { StorageConstants } from "@/enums/storage.enum";
import { Helper } from "@/services/helper";
import { AppsConstraints } from "@/enums/apps.enum";
import store from "@/store/index";

// handle un authorized
const handleUnAuthorized = async () => {
  await store.commit("User/SET_IS_USER_AUTHORIZED", false);
};

axios.defaults.baseURL = ENDPOINTS.BASE_URL;

axios.interceptors.request.use(
  async (config) => {
    config.baseURL = ENDPOINTS.BASE_URL;
    config.headers.common["Accept"] = "application/json";
    config.headers.common["Content-Type"] = "application/json";

    const isOOCUri = Helper.searchOnString(config.url, ENDPOINTS.OOC_BASE_URL);
    const token = Storage.get(StorageConstants.TOKEN);
    const oocToken = Storage.get(StorageConstants.OOC_TOKEN);

    // set OOC Token
    if (isOOCUri && !!oocToken) {
      config.headers.common["Authorization"] = `JWT ${oocToken}`;
    }

    // set Dashboard App Token
    if (!isOOCUri && !!token) {
      config.headers.common["Authorization"] = `POS ${token}`;
    }

    if (Helper.getURIAppName() === AppsConstraints.CALLCENTER) {
      config.headers.common[
        "X-POS-User-Agent"
      ] = `POSRocket/CC/4.9174.425778044565.1768329063239905255674738455/24191266669450815944065436/2710616.57187628578492/57mcSSoTZMkDAySRjkJ68Gn0qkcQ4`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const { response } = error;

    if (response?.data?.error?.code === 401) {
      await handleUnAuthorized();
    }
    return Promise.reject(response?.data || response || error);
  }
);

export default axios;
